// extracted by mini-css-extract-plugin
export default {"logoContainer":"logo_logoContainer__AIMRL","logoText":"logo_logoText__kuXR3"};